module.exports = __webpack_public_path__ + "img/asuparticipa.2c0a4ae1.png";